module.exports = __webpack_public_path__ + "img/salvaged.sword.1167ee3b.png";